import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { UiSchemaCollection } from "@vp/formly/ui-schema-config";
import { CacheService } from "@vp/shared/services/cache";
import { API_BASE_URL } from "@vp/shared/tokens";

import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class UiSchemaApiService {
  private apiBaseUrl = inject(API_BASE_URL);
  private cacheService = inject<CacheService<UiSchemaCollection[]>>(CacheService);
  private http = inject(HttpClient);

  get = (): Observable<UiSchemaCollection[]> => {
    if (!this.cacheService.has("UiSchemaApiService.get")) {
      return this.getInternal().pipe(
        tap(uiSchemas => {
          this.cacheService.set("UiSchemaApiService.get", uiSchemas);
        })
      );
    }
    return this.cacheService.get("UiSchemaApiService.get", this.getInternal());
  };

  private getInternal = () => {
    return this.http.get<UiSchemaCollection[]>(`${this.apiBaseUrl}/uischemas`);
  };
}
